import React from 'react';
import { withTranslation } from 'react-i18next';
import { StyledFunnelChart } from './newDashboardStyles';
import { EMAIL_DASHBOARD } from './TranslationValues';
const namespaces = ['EMAIL_DASHBOARD'];

const FunnelChart = ({
  t,
  funnelChartData,
  funnelChartColors,
  totalEmailConversions = 0,
  clickable = false,
  onChange,
  selected = [],
}) => {
 
  return (
    <StyledFunnelChart height={'35%'} clickable={clickable}>
      <h2 className="chartTitle">
        {t(EMAIL_DASHBOARD.FUNNEL_SECTION_TITLE.key, EMAIL_DASHBOARD.FUNNEL_SECTION_TITLE.value)}
      </h2>
      <div className="chartContainer">
        <div className="chartData">
          {funnelChartData.map((li, key) => {
            return (
              <div
                className={
                  `dataRow ${clickable && selected.includes(li.title) ? 'selected' : ''}`
                }
                onClick={() => clickable && onChange(li.title)}
              >
                <div className="rowTitle">
                  <div className="identifier" style={{ background: funnelChartColors[key] }}></div>
                  <p>{li.title}</p>
                </div>
                <p>
                  {li.count} <span>({li.percentage}%)</span>
                </p>
              </div>
            );
          })}
          <hr />
          <div className="dataRow">
            <p>
              {t(
                EMAIL_DASHBOARD.FUNNEL_SECTION_TOTAL_CONVERSION_RATE_LABEL.key,
                EMAIL_DASHBOARD.FUNNEL_SECTION_TOTAL_CONVERSION_RATE_LABEL.value,
              )}
            </p>
            <p>
              <span>{totalEmailConversions}%</span>
            </p>
          </div>
        </div>
        <div className="funnel">
          <div className="barsContainer">
            {funnelChartColors.map((li, index) => {
              return (
                <div
                  className={
                    `bars ${clickable && selected.includes(funnelChartData[index].title ? 'selected-bar' : '')}}`
                  }
                  style={{ background: li }}
                  onClick={() =>
                    clickable &&
                    onChange(
                      funnelChartData[index].title
                    )
                  }
                ></div>
              );
            })}
            <div className="skewLeft"></div>
            <div className="skewRight"></div>
          </div>
        </div>
      </div>
    </StyledFunnelChart>
  );
};

export default withTranslation(namespaces)(FunnelChart);
